import React, { useState } from 'react';
import { SamlIdentityProviderPreLoginProps } from './types';
import { SingleSelect } from '../../components/Input/DropdownsOld/SingleSelect/index';
import {
  Title,
  Container,
  Middle,
  StyledButton,
  IdpsContainer,
  ErrorBox,
  ButtonContainer,
  RedirectButton,
  ErrorContainer,
} from './styles';

export const SamlIdentityProviderPreLogin = React.memo(
  (props: SamlIdentityProviderPreLoginProps) => {
    const [samlRedirect, setSamlRedirect] = useState<string | null>(null);
    const [noIdpError, setNoIdpError] = useState<string | undefined>(undefined);

    const { idps, cohortId } = props;
    const onSelectIdp = (value: string | undefined): void => {
      let redirectUrl = value;

      if (value && cohortId) {
        redirectUrl = `${value}${cohortId}/`;
      }
      setSamlRedirect(redirectUrl || null);
      setNoIdpError(undefined);
    };
    const handleButtonClicked = (): void => {
      setNoIdpError('You must select an organisation to sign in with');
    };

    return (
      <Middle>
        {idps.length > 0 ? (
          <Container>
            <Title>Sign in with your organisation</Title>
            <IdpsContainer>
              <SingleSelect
                label="Select your organisation"
                error={noIdpError}
                options={idps.map((idp) => {
                  return {
                    label: idp.name,
                    value: idp.launchUrlBase,
                  };
                })}
                onValueChange={(item) => {
                  onSelectIdp(item?.value);
                }}
              />
            </IdpsContainer>
            <ButtonContainer>
              <RedirectButton>
                {samlRedirect ? (
                  <StyledButton
                    variant="legacy-kelp"
                    action={{ kind: 'external_link', value: samlRedirect }}
                  >
                    Continue
                  </StyledButton>
                ) : (
                  <StyledButton
                    variant="legacy-kelp"
                    action={{ kind: 'on_click', value: handleButtonClicked }}
                  >
                    Continue
                  </StyledButton>
                )}
              </RedirectButton>
            </ButtonContainer>
          </Container>
        ) : (
          <ErrorContainer>
            <div>
              <ErrorBox>
                Error: No identity provider available, please contact your
                institution administrator.
              </ErrorBox>
            </div>
          </ErrorContainer>
        )}
      </Middle>
    );
  }
);
